import { LifePageContentView } from './lifePageContentView';

const props = [];

export const LifePageContentViewDirective = reactDirective => reactDirective(LifePageContentView, props);
LifePageContentViewDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('lifePageContentView', LifePageContentViewDirective);
